import React, { useEffect, useState } from "react";
import { Mail, Smartphone, RefreshCw, CheckCircle2, XCircle, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { PageHeader, Section, LoadingBlock } from "../../components/app/ui";
import { publicApi, errorMessage, API_BASE } from "../../lib/api";

const CHANNELS = [
  { key: "email", label: "Email", icon: Mail, text: "OTP codes, receipts and account notices." },
  { key: "sms", label: "SMS", icon: Smartphone, text: "Phone OTP and ride updates." },
];

export default function NotificationsStatus() {
  const [status, setStatus] = useState(null);
  const [checkedAt, setCheckedAt] = useState(null);
  const load = () => publicApi.notificationsStatus().then((s) => { setStatus(s); setCheckedAt(new Date()); }).catch((e) => toast.error(errorMessage(e)));
  useEffect(() => { load(); }, []);

  return (
    <>
      <PageHeader title="Notifications status" description="Live health of the messaging channels used for OTP and updates." actions={<Button variant="outline" onClick={load} className="rounded-full" data-testid="notif-refresh"><RefreshCw className="mr-2 h-4 w-4" /> Re-check</Button>} />
      {!status ? <LoadingBlock rows={3} /> : (
        <>
          {status.dev_mock && (
            <div className="mb-6 flex items-start gap-3 rounded-2xl border border-brand-200 bg-brand-50 p-5" data-testid="notif-mock-banner">
              <FlaskConical className="mt-0.5 h-5 w-5 text-brand" />
              <div><p className="font-semibold text-ink">Development mock is ON</p><p className="text-sm text-ink-soft">Channels without a provider key return a fixed test OTP instead of sending real messages. Set NOTIFICATIONS_DEV_MOCK=false and configure provider keys on the backend to go live.</p></div>
            </div>
          )}
          <div className="grid gap-4 md:grid-cols-3" data-testid="notif-channels">
            {CHANNELS.map((c) => {
              const on = !!status[c.key];
              return (
                <div key={c.key} className={`kt-card p-6 ${on ? "border-graphite-200" : ""}`} data-testid={`notif-${c.key}`}>
                  <div className="flex items-center justify-between">
                    <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${on ? "bg-graphite-50 text-graphite" : "bg-surface-200 text-ink-muted"}`}><c.icon className="h-5 w-5" /></span>
                    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${on ? "bg-graphite text-white" : "bg-surface-200 text-ink-soft"}`}>{on ? <CheckCircle2 className="h-3.5 w-3.5" /> : <XCircle className="h-3.5 w-3.5" />}{on ? "Configured" : "Not configured"}</span>
                  </div>
                  <h3 className="mt-4 text-lg font-semibold text-ink">{c.label}</h3>
                  <p className="mt-1 text-sm text-ink-soft">{c.text}</p>
                </div>
              );
            })}
          </div>
          <Section title="Details" className="mt-6">
            <dl className="grid gap-3 text-sm sm:grid-cols-2">
              <div className="rounded-xl bg-surface-100 p-4"><dt className="text-ink-soft">Sender brand</dt><dd className="mt-1 font-semibold text-ink">{status.brand || "-"}</dd></div>
              <div className="rounded-xl bg-surface-100 p-4"><dt className="text-ink-soft">Backend</dt><dd className="mt-1 truncate font-semibold text-ink">{API_BASE}</dd></div>
              <div className="rounded-xl bg-surface-100 p-4"><dt className="text-ink-soft">Dev mock</dt><dd className="mt-1 font-semibold text-ink">{status.dev_mock ? "Enabled" : "Disabled"}</dd></div>
              <div className="rounded-xl bg-surface-100 p-4"><dt className="text-ink-soft">Last checked</dt><dd className="mt-1 font-semibold text-ink">{checkedAt?.toLocaleTimeString("en-IN")}</dd></div>
            </dl>
          </Section>
        </>
      )}
    </>
  );
}
